var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkAsRetested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Info/Mark-as-Retested",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0 C15.1045695,0 16,0.8954305 16,2 L16,14 C16,15.1045695 15.1045695,16 14,16 L2,16 C0.8954305,16 0,15.1045695 0,14 L0,2 C0,0.8954305 0.8954305,0 2,0 L14,0 Z M14,1.5 L2,1.5 C1.75454011,1.5 1.55039163,1.67687516 1.50805567,1.91012437 L1.5,2 L1.5,14 C1.5,14.2454599 1.67687516,14.4496084 1.91012437,14.4919443 L2,14.5 L14,14.5 C14.2454599,14.5 14.4496084,14.3231248 14.4919443,14.0898756 L14.5,14 L14.5,2 C14.5,1.75454011 14.3231248,1.55039163 14.0898756,1.50805567 L14,1.5 Z M9,3.5 C11.0710678,3.5 12.75,5.17893219 12.75,7.25 C12.75,9.25425917 11.1776389,10.8912737 9.19915857,10.994802 L9,11 L6.811,11 L7.53033009,11.7196699 C7.79659665,11.9859365 7.8208027,12.4026002 7.60294824,12.6962117 L7.53033009,12.7803301 C7.26406352,13.0465966 6.84739984,13.0708027 6.55378835,12.8529482 L6.46966991,12.7803301 L4.46966991,10.7803301 C4.20340335,10.5140635 4.1791973,10.0973998 4.39705176,9.80378835 L4.46966991,9.71966991 L6.46966991,7.71966991 C6.76256313,7.4267767 7.23743687,7.4267767 7.53033009,7.71966991 C7.79659665,7.98593648 7.8208027,8.40260016 7.60294824,8.69621165 L7.53033009,8.78033009 L6.81,9.5 L9,9.5 C10.2426407,9.5 11.25,8.49264069 11.25,7.25 C11.25,6.05913601 10.3248384,5.08435508 9.15404881,5.00519081 L9,5 L4,5 C3.58578644,5 3.25,4.66421356 3.25,4.25 C3.25,3.87030423 3.53215388,3.55650904 3.89822944,3.50684662 L4,3.5 L9,3.5 Z",
    id: "Shape",
    fill: "#8C9BC0",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsRetested);
export default __webpack_public_path__ + "static/media/mark-as-retested.f3226ec8e0a4ec95587bd02e1bbb1207.svg";
export { ForwardRef as ReactComponent };